import React from 'react';
import AWS from "aws-sdk";
import {Link} from 'react-router-dom'

import {
  Table,
  TableBody,
// ***  TableHeader,
// ***  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
// *** import {grey400, darkBlack, lightBlack, red500} from 'material-ui/styles/colors';
import {grey400, lightBlack, red500} from 'material-ui/styles/colors';
import ActionList from 'material-ui/svg-icons/action/list';

import appConfig from '../appConfig';
// *** import {bucketname,tablename,commenttable,toLocaleString,makeCommentKey,noimage,noimageurl,nothumbnailurl,cachepath}  from '../appConfig';
import {bucketname,tablename,noimage,nothumbnailurl,cachepath}  from '../appConfig';
import Counter from './Counter';


export default class HomeApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
       items: []
    };
  }

  componentWillMount() {
    const _self=this;
    const dynamo = new AWS.DynamoDB.DocumentClient();
    const s3 = new AWS.S3();


    //--- try to get cache
    var params = {
        Bucket: bucketname,
        Key: cachepath
    };
    s3.getObject(params, function(err, data) {
        if (! err ) {
            console.log("### cache available!!!");
            const object = JSON.parse(data.Body.toString());
            _self.setState({items: object});
        } else {
        //--- table query
            console.log("### cache unavailable!!! query table!!!");
            const today = new Date();
            const currentYear = today.getFullYear();
            var param = {
              TableName : tablename,
              IndexName: "partitionYear-uploadTime-index",
              ScanIndexForward: false, //queryには効くが、scanには効かない
              ExpressionAttributeNames : {'#k' : 'partitionYear'},
              ExpressionAttributeValues : {':partitionYear' : 2017},
              KeyConditionExpression : '#k = :partitionYear',
              Limit: 20
            };
            dynamo.query(param, function(err, data) {
                if (err) {
                    console.log("### Error="+err);
                } else {
                    //console.log("### data="+JSON.stringify(data.Items));
                    _self.setState({items: data.Items});
                    //--- cache update
                    var params = {
                        Bucket: bucketname,
                        Key: cachepath,
                        ContentType: 'application/json',
                        Body: JSON.stringify(data.Items)
                    };
                    s3.putObject(params, function(err, data) {
                      if (err) console.log("### cache upload error",err, err.stack); // an error occurred
                      else     console.log("### cache upload successful"+data);           // successful response
                    });
                }
            });
        }
    });
  }




  render () {

    let list=[];
    this.state.items.map((item,idx) => {
        let imgurl = nothumbnailurl;
        if(item.thumbnail!==noimage) {
            imgurl = 'http://'+bucketname+'.s3-'+appConfig.region+'.amazonaws.com/'+item.thumbnail;
        }
        list.push (
            <TableRow key={idx} valign={'top'}>
              <TableRowColumn width={200}>
                  <Link to={{ pathname:'/post', state:item }}>
                      <img alt="img" src={imgurl} />
                  </Link>
              </TableRowColumn>
              <TableRowColumn align={'left'} style={{whiteSpace: "normal",wordWrap: "break-word"}}>
                  <h3>{item.title}</h3>
                  <div>{item.username} / {item.uploadDate}</div>
                  <br />
                  <div style={{fontSize:14}}>{item.story}</div>
                  <br />
              </TableRowColumn>
            </TableRow>
        )
        return item // *** for compile err
    })


    return (
      <div>
        <div style={{fontSize: 14, alignText: 'left'}}></div>
        <div style={{width:'80%', marginLeft: 'auto', marginRight: 'auto'  }}>
          <p style={{textAlign: 'left', color:lightBlack}}>久喜市の最新情報を画像とマップで伝えていきましょう。メールアドレスを登録するだけで誰でも投稿できます。</p>
          <ul>
              <li style={{display:'inline-block', marginLeft:20}}><a href="https://s3-ap-northeast-1.amazonaws.com/kuki-app-bucket/saitama/treemap-saitama.html">埼玉県地域別人口ツリーマップ</a></li>
              <li style={{display:'inline-block', marginLeft:20}}><a href="https://s3-ap-northeast-1.amazonaws.com/kuki-app-bucket/saitama/tree-saitama.html">ツリー版</a></li>
              <li style={{display:'inline-block', marginLeft:20}}><a href="https://s3-ap-northeast-1.amazonaws.com/kuki-app-bucket/saitama/pack-saitama.html">パックチャート版</a></li>
          </ul>
          <br />
          <div style={{textAlign: 'right', color:grey400}}>
              <Counter identityId={'topPageCounter'} uploadTime={999} />
          </div>
          <div style={{textAlign: 'left', verticalAlign: 'top', color: lightBlack}}>
              <ActionList style={{marginRight: 12}}  color={red500}  /><br />
              最新投稿
          </div>
          <br /><br />
          <Table selectable={false} style={{ tableLayout: 'auto'}}>
            <TableBody displayRowCheckbox={false}>
            {list}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/views/Home.js